import ClientScreen from './ClientScreen'

export default ClientScreen
